/** BBRewardCategory — 与 GraphQL / bbAdminCreateReward 一致 */
export const BB_REWARD_CATEGORIES = [
  'CASH_USDC',
  'CASH_OTHER',
  'CRYPTO',
  'XP',
  'PHYSICAL',
  'SPIN',
  'BOX',
  'PREDICTION_TICKET',
] as const;

export type BBRewardCategory = (typeof BB_REWARD_CATEGORIES)[number];

export const BB_REWARD_CATEGORY_WHEEL_DEFAULTS: BBRewardCategory[] = [
  'CASH_USDC',
  'XP',
  'PHYSICAL',
  'CRYPTO',
  'CASH_OTHER',
  'SPIN',
  'PREDICTION_TICKET',
];

export const BB_REWARD_CATEGORY_BOX_DEFAULTS: BBRewardCategory[] = [
  'CASH_USDC',
  'XP',
  'PHYSICAL',
  'CRYPTO',
  'CASH_OTHER',
  'BOX',
];

/** reward-feed / win-records 筛选用 */
export const BB_REWARD_CATEGORY_FILTER_OPTIONS: BBRewardCategory[] = [
  'CASH_USDC',
  'XP',
  'PHYSICAL',
  'SPIN',
  'BOX',
  'PREDICTION_TICKET',
];

export function isPredictionTicket(category?: string | null): boolean {
  return category === 'PREDICTION_TICKET';
}

export function validatePredictionTicketReward(params: {
  sourceModule: string;
  rewardCategory?: string;
  amount?: string;
  totalPool?: number;
  tokenType?: string | null;
}): string | null {
  if (!isPredictionTicket(params.rewardCategory)) return null;
  if (params.sourceModule !== 'WHEEL') {
    return 'PREDICTION_TICKET only supports sourceModule=WHEEL';
  }
  if (params.tokenType) {
    return 'PREDICTION_TICKET requires tokenType to be empty';
  }
  const amt = parseFloat(String(params.amount ?? ''));
  if (!Number.isFinite(amt) || !Number.isInteger(amt) || amt <= 0) {
    return 'PREDICTION_TICKET amount must be a positive whole number (ticket count)';
  }
  if (!params.totalPool || params.totalPool <= 0) {
    return 'PREDICTION_TICKET requires totalPool > 0';
  }
  return null;
}
